import { createSelector } from 'reselect';

import { getMerchant } from './common';

export const getBankAccounts = createSelector(
  getMerchant,
  ({ bankAccounts }) => bankAccounts || [],
);
